import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { GET_ALL_FIELDS_V2 } from '@nile/banyan/src/Graphql/Mutations/ticket';
import {
  ALL_SHARD_MODULES,
  B1,
  DisabledTag,
  getTranslatedText,
  H1,
  Loader,
  useIsAuthorisedHook
} from '@nile/components';
import { SVGIcon } from '@superops/super-icons';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  Button,
  ButtonGroup,
  Page,
  Sheet,
  TextField
} from '@superops/ui-design-system';
import { AccountClient, GET_INACTIVE_FIELDS } from '@nile/graphql';
import styled from 'styled-components';

function AdditionalProperties({
  mode,
  actions,
  fieldsData,
  onChangeHandler,
  filterFields
}) {
  const isInvoiceCustomFieldsAuthorised = useIsAuthorisedHook(
    'billingCustomFields.view'
  );

  const { data: billingFields, loading: billingFieldsLoading } = useQuery(
    GET_ALL_FIELDS_V2,
    {
      client: AccountClient,
      variables: {
        input: ALL_SHARD_MODULES.invoice
      },
      skip: !isInvoiceCustomFieldsAuthorised
    }
  );

  const { data: inactiveFields, loading: inactiveFieldsLoading } = useQuery(
    GET_INACTIVE_FIELDS,
    {
      client: AccountClient,
      variables: {
        input: ALL_SHARD_MODULES.invoice
      },
      skip: !isInvoiceCustomFieldsAuthorised
    }
  );

  if (billingFieldsLoading || inactiveFieldsLoading) {
    return <Loader />;
  }

  const billingCustomFields = billingFields?.getAllFields?.filter(
    (field) => field?.fieldCategory === 'CUSTOM'
  );

  const inactiveFieldsData = inactiveFields?.getInactiveFields?.filter(
    (field) => field?.fieldCategory === 'CUSTOM'
  );

  const fieldsToRender = [...billingCustomFields, ...inactiveFieldsData]
    .filter((field) => !filterFields?.includes(field?.columnName))
    .filter((field) => {
      if (field?.status === 'INACTIVE') {
        return fieldsData?.[field?.columnName];
      }
      return true;
    });

  return (
    <div
      className={`fhp white-bg br10 ${
        actions?.handleSave ? 'width-600' : 'w400'
      }`}
    >
      <div
        className={`fx actr divider  mb20 ${
          actions?.handleSave ? 'p20' : 'p20'
        }`}
      >
        {/* {!actions?.handleSave ? (
          <Button
            onClick={actions?.onClose}
            icon={<SVGIcon name="RightDoubleArrow" />}
            plain
          />
        ) : null} */}
        <H1>
          <B1>
            <FormattedMessage id="client.new.additional.label" />
          </B1>
        </H1>
        {actions?.handleSave ? (
          <div className="mlauto">
            <ButtonGroup>
              <Button plainSecondary onClick={actions?.onClose}>
                <FormattedMessage id="common.cancel" />
              </Button>
              <Button primary onClick={actions?.handleSave}>
                <FormattedMessage id="common.save" />
              </Button>
            </ButtonGroup>
          </div>
        ) : null}
      </div>
      {fieldsToRender?.length ? (
        <div className="fx col g20 p2040 ch-125 scroll">
          {fieldsToRender?.map((field) => {
            return (
              <div key={field?.columnName}>
                <FormattedMessage
                  id={field?.label || `attribute.${field?.columnName}`}
                />
                <TextField
                  type="text"
                  label={field?.label || `attribute.${field?.columnName}`}
                  labelHidden
                  autoComplete="off"
                  value={fieldsData?.[field?.columnName] || ''}
                  onChange={(val) => {
                    onChangeHandler(field?.columnName, val);
                  }}
                  disabled={mode === 'view' || field?.status === 'INACTIVE'}
                />
              </div>
            );
          })}
        </div>
      ) : (
        <div className="fx fcol actr jctr ch-125">
          <DisabledTag>
            <FormattedMessage id="admin.mandatoryTicketFields.list.noData.heading" />
          </DisabledTag>
        </div>
      )}
    </div>
  );
}

function AdditionalPropertiesHolder(props) {
  const {
    mode,
    sheetActive,
    filterFields,
    isLargeScreen,
    onChangeHandler,
    customFieldsData,
    toggleSheetActive
  } = props;

  const [fieldsData, setFieldsData] = useState(customFieldsData || {});

  function handleChange(field, value) {
    if (isLargeScreen) {
      setFieldsData({
        ...fieldsData,
        [field]: value
      });
      onChangeHandler({
        ...fieldsData,
        [field]: value
      });
    } else {
      setFieldsData({
        ...fieldsData,
        [field]: value
      });
    }
  }

  function handleSave() {
    const entries = Object.fromEntries(
      Object.entries(fieldsData).filter(([key]) => !filterFields?.includes(key))
    );
    onChangeHandler(entries);
    toggleSheetActive();
  }

  if (!isLargeScreen) {
    return (
      <Sheet
        size="default"
        open={sheetActive}
        onClose={toggleSheetActive}
        accessibilityLabel="AdditionalProperties"
      >
        <div className="fh scroll bg-white">
          <AdditionalProperties
            actions={{
              handleSave: handleSave,
              onClose: toggleSheetActive
            }}
            mode={mode}
            filterFields={filterFields}
            fieldsData={fieldsData}
            onChangeHandler={handleChange}
          />
        </div>
      </Sheet>
    );
  }
  return (
    <AdditionalProperties
      mode={mode}
      actions={{
        onClose: toggleSheetActive
      }}
      filterFields={filterFields}
      fieldsData={fieldsData}
      onChangeHandler={handleChange}
    />
  );
}

export default AdditionalPropertiesHolder;
